// DS: C92
import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiDataHook } from '../../../biLogger/constants';
import Flex from '../../../Flex';
import { IconSize } from '../../../Icons/IconWrap';
import shortenNumber from '../../../utils/shortenNumber';
import { getDeviationStats } from './helpers';
import { useFlag } from '../../../redux/flags/hooks';
import { MobileContext } from '../../../Context/MobileContext';
import FavouriteIcon from '../../../Icons/Favourite';
import CommentIcon from '../../../Icons/Comment';
import Eyecon from '../../../Icons/Eye';
import WhoTooltipWrapper from './WhoTooltipWrapper';
import CoreBadgeList from '../CoreBadgeList';
import s from './Stats.actionbarrr.scss';
var Stats = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    var hasCoreBadges = useFlag('core_badges');
    var isMobile = useContext(MobileContext);
    var _b = getDeviationStats(deviation), faves = _b.faves, comments = _b.comments, views = _b.views, isFavouritable = _b.isFavouritable, isCommentable = _b.isCommentable, isViewCountable = _b.isViewCountable;
    var shorten = function (number) { return shortenNumber(number, 0, Math.floor); };
    var statItems = [
        isFavouritable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "favourite", dataHook: BiDataHook.DEVIATION_FAVES_COUNTER, tooltipDataHook: BiDataHook.DEVIATION_FAVERS_LIST },
            React.createElement(FavouriteIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: s['stat-icon'] }),
            isMobile
                ? shorten(faves)
                : t('deviation.stats.faves', {
                    count: faves,
                    formattedCount: shorten(faves),
                }))),
        isCommentable && (React.createElement(WhoTooltipWrapper, { deviation: deviation, userListType: "comment", dataHook: BiDataHook.DEVIATION_COMMENTS_COUNTER },
            React.createElement(CommentIcon, { size: IconSize.SMALL, disableDefaultColors: true, className: classnames(s['stat-icon'], 
                // don't ask, please
                s['pixel-pushing-for-no-good-reason']) }),
            isMobile
                ? shorten(comments)
                : t('deviation.stats.comments', {
                    count: comments,
                    formattedCount: shorten(comments),
                }))),
        isViewCountable && (React.createElement("span", null,
            React.createElement("span", { className: s['views'] },
                React.createElement(Eyecon, { size: IconSize.SMALL, disableDefaultColors: true, className: classnames(s['stat-icon'], 
                    // don't ask, please
                    s['pixel-pushing-for-no-good-reason']) }),
                isMobile
                    ? shorten(views)
                    : t('deviation.stats.views', {
                        count: views,
                        formattedCount: shorten(views),
                    })))),
    ];
    return (React.createElement(Flex, { className: s['root'], alignItems: "center" },
        React.createElement(Flex, { className: s['all-the-stats'], alignItems: "center" }, statItems
            .filter(function (item) { return item; })
            .map(function (item, idx) { return (React.createElement(React.Fragment, { key: idx },
            idx > 0 && React.createElement("div", { className: s['separator'] }),
            item)); })),
        hasCoreBadges && React.createElement(CoreBadgeList, { deviation: deviation })));
};
export default Stats;
//# sourceMappingURL=Stats.actionbarrr.js.map